import { NavLink } from "react-router-dom";
import useAuth from "../../utils/authentication";
//Import dropdown component
import React from 'react';
import routes from "../../settings/routes";
import DropdownMenu from "../menus/Dropdown";

export const portalLinks = [
  { link: "/pages/page/136", title: "Home Schooling" },
];

export const pagesLinks = [
  { link: "/pages/home", title: "Pages Home" },
  { link: "/pages/browse", title: "Browse Pages" },
  { link: "/pages/my-pages", title: "My Pages" },
  { link: "/pages/pinboard", title: "Pinboard" },
  { link: "/pages/claim", title: "Claim a Page" },
  { link: "/pages/home-schooling", title: "Home Schooling" },
];

export const groupsLinks = [];

function Nav() {
  const { authed, login, logout, userId } = useAuth();

  return (
    <div className="default-header-nav">
      {/* <Link to="/home">My News Feed</Link>
            <Link to="/profile">My Profile</Link>
            <Link to="/profile/friends">My Friends</Link>
            <DropdownMenu title="Portals" mainLink="/portals" links={portalLinks} menuVariant="light" className="default-header-nav-dropdown"/>
            <DropdownMenu title="Pages" mainLink="/pages" links={pagesLinks} menuVariant="light" className="default-header-nav-dropdown" />
            <Link to="/groups">Groups</Link>
            <Link to="/faq">FAQs</Link>
            <Link to="/home">More</Link> */}

      {routes.map((item, i) => {
        if (item.nav !== true) return;

        if (item.navOptions.subMenu) {
          let submenu_links = item.navOptions.subMenu.map((val) => ({ ...val }));
          if (
            item.navOptions.link &&
            item.navOptions.link.includes("profile")
          ) {
            item.navOptions.link = item.navOptions.link.replace(
              ":id",
              userId || "",
            );

            submenu_links = submenu_links.map((val) => {
              val.link = val.link.replace(
                ":id",
                userId || "",
              );
              return val;
            });
          }

          return (
            <DropdownMenu
              className="default-header-nav-dropdown"
              title={item.navOptions.name}
              mainLink={item.navOptions.link}
              links={submenu_links}
              icon={item.navOptions.icon}
              key={`nav-dd-${i}`}
            />
          );
        } else {
          return (
            <NavLink
              to={
                item.navOptions.link === "/profile" &&
                userId
                  ? `${item.navOptions.link}/${userId}`
                  : item.navOptions.link
              }
              replace
              key={`nav-link-${i}`}
            >
              {item.navOptions.name}
            </NavLink>
          );
        }
      })}
    </div>
  );
}

export default Nav;
